/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_Take_AnywayInputs */

const en_us2_body_assessment_pose_take_anyway = /** @type {(inputs: Body_Assessment_Pose_Take_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take it anyway`)
};

const pt_br2_body_assessment_pose_take_anyway = /** @type {(inputs: Body_Assessment_Pose_Take_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar mesmo assim`)
};

const es_419_body_assessment_pose_take_anyway = /** @type {(inputs: Body_Assessment_Pose_Take_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomarla de todos modos`)
};

const pt_pt2_body_assessment_pose_take_anyway = /** @type {(inputs: Body_Assessment_Pose_Take_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar mesmo assim`)
};

const fr_fr2_body_assessment_pose_take_anyway = /** @type {(inputs: Body_Assessment_Pose_Take_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendre quand même`)
};

const de_de2_body_assessment_pose_take_anyway = /** @type {(inputs: Body_Assessment_Pose_Take_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trotzdem aufnehmen`)
};

const it_it2_body_assessment_pose_take_anyway = /** @type {(inputs: Body_Assessment_Pose_Take_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatta comunque`)
};

/**
* | output |
* | --- |
* | "Take it anyway" |
*
* @param {Body_Assessment_Pose_Take_AnywayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_take_anyway = /** @type {((inputs?: Body_Assessment_Pose_Take_AnywayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_Take_AnywayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_take_anyway(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_take_anyway(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_take_anyway(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_take_anyway(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_take_anyway(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_take_anyway(inputs)
	return en_us2_body_assessment_pose_take_anyway(inputs)
});
export { body_assessment_pose_take_anyway as "body-assessment.pose_take_anyway" }